// @flow strict

export const MicroFrontEnds = {
    reportGenerationSystem: {
        development: 'http://localhost:3000',
        dev: 'https://rgs-fe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://rgs-fe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://rgs-fe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    plantConfiguration: {
        development: 'http://localhost:3001',
        dev: 'https://plant-configuration-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://plant-configuration-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://plant-configuration-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    platformStatus: {
        development: 'http://localhost:3003',
        dev: 'https://platform-status-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://platform-status-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://platform-status-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    platformAuthenticationLogin: {
        development: 'http://localhost:3006',
        dev: 'https://platform-authentication-login-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging:
            'https://platform-authentication-login-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production:
            'https://platform-authentication-login-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    plantDashboard: {
        development: 'http://localhost:3004',
        dev: 'https://plant-dashboard-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://plant-dashboard-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://plant-dashboard-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    cyanex: {
        development: 'http://localhost:4200',
        dev: 'https://cyanex-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://cyanex-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://cyanex-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    reagentsManagement: {
        development: 'http://localhost:4301',
        dev: 'https://reagents-management-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://reagents-management-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://reagents-management-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    minChem: {
        development: 'http://localhost:4205',
        dev: 'https://minchem-frontend-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://minchem-frontend-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://minchem-frontend-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    plantImport: {
        development: 'http://localhost:3007',
        dev: 'https://plant-import-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://plant-import-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://plant-import-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
    geoDashboard: {
        development: 'http://localhost:3009',
        dev: 'https://geo-dashboard-mfe-dot-gcp-sqo-solvextract-d.appspot.com',
        staging: 'https://geo-dashboard-mfe-dot-gcp-sqo-solvextract-u.appspot.com',
        production: 'https://geo-dashboard-mfe-dot-gcp-sqo-solvextract-p.appspot.com',
    }[process.env.NODE_ENV || 'development'],
};
